import { Link } from 'react-router'
import { FormattedMessage } from 'react-intl'
import SocialLinks from '@components/SocialLinks/SocialLinks'
import SupportLogos from '@components/SupportLogos/SupportLogos'

import logo from '@static/vectors/footer-logo.svg'
import './Footer.css'

export default function Footer({ darkTheme = true }: { darkTheme?: boolean }) {
  return (
    <footer
      className={!darkTheme ? 'scheme-ligth' : 'scheme-dark'}
      id="colophon"
    >
      <div className="container">
        <SupportLogos />
      </div>
      <div className="container">
        <section className="row">
          <SocialLinks />
        </section>
        <section className="row">
          <nav className="legal-links">
            <a
              target="_blank"
              href="https://www.adigital.org/aviso-legal/"
              rel="noreferrer"
            >
              <FormattedMessage id="legal.advice.link" />
            </a>
            <Link to="/privacy">
              <FormattedMessage id="legal.privacy.link" />
            </Link>
            {/* <a href="">
              <FormattedMessage id="legal.cookies.link" />
            </a> */}
          </nav>
        </section>
        <section id="image-wrapper" className="row">
          <img src={logo} alt="logo" />
        </section>
      </div>
    </footer>
  )
}
